import React from "react";
import { useState, useEffect } from "react";
import { BsFillArrowUpCircleFill } from "react-icons/bs";

const GotoTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const goTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const listenToScroll = () => {
    let heighToShow = 250;

    const windowScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    if (windowScroll > heighToShow) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", listenToScroll);
    return () => {
      window.removeEventListener("scroll", listenToScroll);
    };
  }, []);

  return (
    <div>
      {isVisible && (
        <div
          className="fixed z-20 right-4 bottom-4 hover:scale-105"
          onClick={goTop}
        >
          <BsFillArrowUpCircleFill
            size={70}
            className="text-[#D6E4E5] active:text-[#B7C4CF]"
          />
        </div>
      )}
    </div>
  );
};

export default GotoTop;
